<div
  class="app-grid-fluid md:mt-3 md:mb-3 py-2"
  appPullToRefresh
  #ptr="appPullToRefresh"
  (refresh)="onPullToRefresh(ptr)"
>
  <div class="grid grid-nogutter justify-content-center">
    <div class="col-12 sm:col-10 xl:col-6" [style]="{maxWidth: '980px'}">
      <p-tabView [scrollable]="true" [activeIndex]="activeTabIndex" (onChange)="onTabChange($event)" styleClass="ranking-tabs screen-sticky-tabview">
        <p-tabPanel *ngFor="let category of categories" [header]="category.label | translate">
          <ng-container *ngIf="activeCategory === category.key">
            <div *ngIf="activeState.error" class="px-3 py-3 muted-text">
              {{ 'common.something_went_wrong' | translate }}
            </div>

            <ng-container *ngIf="isProjectTab(category.key)">
              <p-dataView *ngIf="activeState.projects.length" [value]="activeState.projects" [paginator]="false" [rows]="pageSize">
                <ng-template let-projects pTemplate="list">
                  <div *ngFor="let project of projects; index as i" class="col-12 p-0 m-0 mb-2">
                    <p-card *ngIf="project.isPlaceholder">
                      <div class="grid">
                        <div class="col-1 justify-content-center align-items-center ranking-number hidden md:flex">
                          {{ getProjectRank(i, category.key) }}.
                        </div>
                        <div class="col">
                          <div class="col-12 p-0 pt-2 pb-2 vehicle-name white-space-nowrap overflow-hidden text-overflow-ellipsis">
                            <p-skeleton width="70%" height="1.2rem"></p-skeleton>
                          </div>
                          <div class="col-12">
                            <div class="grid">
                              <div class="col-5 p-0 theme-box">
                                <p-skeleton styleClass="avatar p-avatar-xl"></p-skeleton>
                              </div>
                              <div class="col pt-0">
                                <div class="grid grid-nogutter">
                                  <div class="col-12 white-space-nowrap overflow-hidden text-overflow-ellipsis mb-2">
                                    <p-skeleton width="60%" height="1.1rem"></p-skeleton>
                                  </div>
                                  <div class="col-12 p-0 mb-2" style="font-size: 1.1em">
                                    <p-skeleton width="50%" height="1.1rem"></p-skeleton>
                                  </div>
                                  <div class="col-12 p-0 mb-2" style="font-size: 1.1em">
                                    <p-skeleton width="80%" height="1.1rem"></p-skeleton>
                                  </div>
                                  <div class="col-12 p-0 mb-2" style="font-size: 1.1em">
                                    <p-skeleton width="35%" height="1.1rem"></p-skeleton>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </p-card>

                    <p-card *ngIf="!project.isPlaceholder">
                      <div class="grid">
                        <div class="col-1 justify-content-center align-items-center ranking-number hidden md:flex">
                          {{ getProjectRank(i, category.key) }}.
                        </div>
                        <div class="col">
                          <div class="col-12 p-0 pt-3 pb-2 vehicle-name white-space-nowrap overflow-hidden text-overflow-ellipsis">
                            <a class="no-underline">{{ project.vehicle.fullVehicleIdentity }}</a>
                          </div>
                          <div class="col-12">
                            <div class="grid">
                              <div class="col-5 p-0 theme-box">
                                <p-avatar
                                  size="xlarge"
                                  styleClass="avatar"
                                  image="{{project.theme | mediaObject: {defaultImageType: getDefaultImageType(project)} }}"
                                >
                                  <div class="justify-content-center align-items-center ranking-number md:hidden flex">
                                    <span>{{ getProjectRank(i, category.key) }}.</span>
                                  </div>
                                </p-avatar>
                              </div>
                              <div class="col pt-0">
                                <div class="grid grid-nogutter">
                                  <div class="col-12 white-space-nowrap overflow-hidden text-overflow-ellipsis mb-2">
                                    <i class="pi pi-user mr-2"></i>
                                    <a *ngIf="project.user?.slug; else rankingProjectOwnerName" [routerLink]="['/', project.user.slug, 'profile']">{{ project.user.username }}</a>
                                    <ng-template #rankingProjectOwnerName>
                                      <span>{{ project.user.username }}</span>
                                    </ng-template>
                                  </div>

                                  <ng-container *ngIf="category.key !== 'strongest'; else strongestMetrics">
                                    <div class="col-12 p-0 flex mb-2 gap-2" style="font-size: 1.1em">
                                      <div class="rating inline-flex gap-1">
                                        <ng-container *ngFor="let star of [1, 2, 3, 4, 5, 6]">
                                          <i [ngClass]="getIconForStar(star, project.averageRating?.toPrecision ? project.averageRating.toPrecision(3) : project.averageRating)"></i>
                                        </ng-container>
                                      </div>
                                    </div>
                                    <div *ngIf="!project.user.settings?.privacy?.hideRating" class="col-12 p-0 mb-2" style="font-size: 1.1em;">
                                      {{ 'common.ratings_average_short'|translate }}
                                      <span class="count">{{ project.averageRating?.toPrecision ? project.averageRating.toPrecision(3) : project.averageRating }}</span>
                                      {{ 'common.from'|translate }}
                                      <span class="count">{{ project.ratingCount }}</span>
                                      {{ 'common.ratings'|translate | translateSelector: project.ratingCount }}
                                    </div>
                                    <div class="col-12 p-0 mb-2 inline-flex align-items-center" style="font-size: 1.1em">
                                      {{ 'common.your_rate'|translate }}:
                                      <span *ngIf="project.currentUserRating > 0" class="ranking-rate px-1">{{ project.currentUserRating }}</span>
                                      <ng-container *ngIf="project.currentUserRating === 0">~</ng-container>
                                    </div>
                                  </ng-container>

                                  <ng-template #strongestMetrics>
                                    <div class="col-12 p-0 mb-2 metric-line" style="font-size: 1.05em">
                                      {{ 'feature.user.project.parameters.power' | translate }}:
                                      <span class="count">{{ getStrongestMetrics(project).power ?? '—' }}</span>
                                      <span *ngIf="getStrongestMetrics(project).power !== undefined">{{ 'common.bhp' | translate }}</span>
                                    </div>
                                    <div class="col-12 p-0 mb-2 metric-line" style="font-size: 1.05em">
                                      {{ 'feature.user.project.parameters.max_speed' | translate }}:
                                      <span class="count">{{ getStrongestMetrics(project).maxSpeed ?? '—' }}</span>
                                      <span *ngIf="getStrongestMetrics(project).maxSpeed !== undefined">{{ 'common.km_h' | translate }}</span>
                                    </div>
                                    <div class="col-12 p-0 mb-2 metric-line" style="font-size: 1.05em">
                                      {{ 'feature.user.project.parameters.acceleration' | translate }}:
                                      <span class="count">{{ getStrongestMetrics(project).acceleration ?? '—' }}</span>
                                      <span *ngIf="getStrongestMetrics(project).acceleration !== undefined">{{ 'common.s' | translate }}</span>
                                    </div>
                                  </ng-template>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-fixed pl-0 flex flex-column justify-content-center">
                          <button pButton pRipple icon="pi pi-warehouse" class="p-button-outlined p-button-rounded p-button-primary p-button-sm m-1" type="button" (click)="openGarage(project, $event)"></button>
                          <button pButton pRipple icon="pi pi-car" class="p-button-outlined p-button-rounded p-button-primary p-button-sm m-1" type="button" (click)="openProject(project, $event)"></button>
                          <button pButton pRipple icon="pi pi-user" class="p-button-outlined p-button-rounded p-button-primary p-button-sm m-1" type="button" (click)="openProfileForProject(project, $event)" [disabled]="!project.user?.slug"></button>
                          <button pButton pRipple icon="pi pi-qrcode" class="p-button-outlined p-button-rounded p-button-primary p-button-sm m-1" type="button" (click)="openQrDialog(project, $event)"></button>
                        </div>
                      </div>
                    </p-card>
                  </div>
                </ng-template>
              </p-dataView>

              <div *ngIf="!activeState.loading && !hasProjects && !activeState.error" class="width-100 flex justify-content-center mb-3 pt-1 muted-text text-center">
                {{ 'common.no_results' | translate }}
              </div>
            </ng-container>

            <ng-container *ngIf="category.key === 'users'">
              <div *ngFor="let record of activeState.users; index as i" class="col-12 p-0 m-0 mb-2">
                <p-card>
                  <div class="grid align-items-center">
                    <div class="col-1 justify-content-center align-items-center ranking-number hidden md:flex">
                      {{ getProjectRank(i, category.key) }}.
                    </div>
                    <div class="col-auto pr-0">
                      <div class="ranking-user-avatar">
                        <p-avatar
                          *ngIf="record.user.avatar; else rankingUserAvatarFallback"
                          [image]="record.user.avatar | mediaObject: {defaultImageType: 'avatar', formatType: 'thumb_sm'}"
                          size="xlarge"
                          styleClass="avatar"
                        >
                          <div class="justify-content-center align-items-center ranking-number ranking-number-user md:hidden flex">
                            <span>{{ getProjectRank(i, category.key) }}.</span>
                          </div>
                        </p-avatar>
                        <ng-template #rankingUserAvatarFallback>
                          <p-avatar
                            [label]="record.user.username?.slice(0, 1)"
                            size="xlarge"
                            styleClass="avatar"
                          >
                            <div class="justify-content-center align-items-center ranking-number ranking-number-user md:hidden flex">
                              <span>{{ getProjectRank(i, category.key) }}.</span>
                            </div>
                          </p-avatar>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col">
                      <div class="font-medium mb-2">
                        <a *ngIf="record.user?.slug; else rankingUserName" [routerLink]="['/', record.user.slug, 'profile']">{{ record.user.username }}</a>
                        <ng-template #rankingUserName>
                          <span>{{ record.user.username }}</span>
                        </ng-template>
                      </div>
                      <div class="mb-1">
                        {{ 'features.ranking.user.average_rating' | translate }}:
                        <span class="count">{{ record.averageRating }}</span>
                      </div>
                      <div class="mb-1">
                        {{ 'features.ranking.user.ratings_count' | translate }}:
                        <span class="count">{{ record.ratingCount }}</span>
                      </div>
                      <div>
                        {{ 'features.ranking.user.ranked_vehicle_count' | translate }}:
                        <span class="count">{{ record.rankedVehicleCount }}</span>
                      </div>
                    </div>
                    <div class="col-fixed">
                      <button pButton pRipple icon="pi pi-user" class="p-button-outlined p-button-rounded p-button-primary p-button-sm m-1" type="button" (click)="openProfile(record, $event)" [disabled]="!record.user?.slug"></button>
                    </div>
                  </div>
                </p-card>
              </div>

              <div *ngIf="activeState.loading && !activeState.users.length" class="px-2">
                <p-card *ngFor="let item of [1,2,3,4]" styleClass="mb-2">
                  <div class="grid align-items-center">
                    <div class="col-auto">
                      <div class="ranking-user-avatar">
                        <p-skeleton width="5rem" height="5rem" styleClass="ranking-user-avatar-skeleton"></p-skeleton>
                      </div>
                    </div>
                    <div class="col">
                      <p-skeleton width="40%" height="1.1rem" styleClass="mb-2"></p-skeleton>
                      <p-skeleton width="55%" height="1rem" styleClass="mb-2"></p-skeleton>
                      <p-skeleton width="50%" height="1rem" styleClass="mb-2"></p-skeleton>
                    </div>
                  </div>
                </p-card>
              </div>

              <div *ngIf="!activeState.loading && !hasUsers && !activeState.error" class="width-100 flex justify-content-center mb-3 pt-1 muted-text text-center">
                {{ 'common.no_results' | translate }}
              </div>
            </ng-container>

            <p-paginator
              *ngIf="activeState.total > activeState.limit"
              [rows]="activeState.limit"
              [totalRecords]="activeState.total"
              [first]="(activeState.page - 1) * activeState.limit"
              [rowsPerPageOptions]="[pageSize]"
              (onPageChange)="onPageChange($event)"
              styleClass="ranking-paginator"
            ></p-paginator>
          </ng-container>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>
<app-qr-dialog [(visible)]="qrDialogVisible" [data]="qrDialogData"></app-qr-dialog>
